import React from 'react'
import { INode } from 'shared/types/tree'
import { NodeIdMap } from '../../version_mapping/utility'
import { Box } from '@mui/material'
import { nodePath } from './utility'

export function NodePath({ node, idMap }: { node: INode; idMap: NodeIdMap }) {
  return <Box>{nodePathString({ node, idMap })}</Box>
}

export function nodePathString({
  node,
  idMap,
}: {
  node: INode
  idMap: NodeIdMap
}) {
  const path = nodePath(node, idMap).map(({ type }) => type)
  return path.join(' -> ')
}
